export enum ResourceTypesEnum {
  BUYER = 'BUYER',
  CATEGORY = 'CATEGORY',
  RFP = 'RFP',
  MARKETPLACE_AGREEMENT = 'MARKETPLACE_AGREEMENT',
}
